// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationItem_wrapper__4xh6v","notReaded":"NotificationItem_notReaded__pDTXp","title":"NotificationItem_title__Hj455"};